<template>
<div class="absolute full right-0">
    <IconExtraOptions class="text-gray-500 hover:text-primary h-6 pt-0-5"/>
    <div class="absolute w-full bg-red-500 w-24 left-0">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laboriosam, nesciunt.
    </div>
</div>
</template>
<script>
export default {}
</script>
